import { ReactElement } from "react"
import { Link } from "react-router-dom"
import { Loading } from "@wfp/ui"
import { useGetLinkedSurveysQuery } from "services/household/xlsFormSchemas"
import ErrorState from "components/Shared/EmptyState/ErrorState"

type Props = {
  xlsFormId: number
}

const XlsSurveyLinked = ({ xlsFormId }: Props): ReactElement => {
  const { data: linkedSurveys, isLoading, error } = useGetLinkedSurveysQuery({ xlsFormId })

  if (isLoading) return <Loading small />
  if (!linkedSurveys?.length)
    return (
      <div className="p-3">
        <p className="font-bold mb-2">No linked surveys found</p>
      </div>
    )
  if (error) return <ErrorState />

  return (
    <div className="p-3">
      <p className="font-bold mb-2">This XLSForm is linked to these surveys:</p>
      {linkedSurveys?.map(survey => (
        <div key={survey.value} className="mb-1">
          <Link to={`/household/surveys/${survey.value}#details`} className="text-brand-01">
            {survey.name}
          </Link>
        </div>
      ))}
    </div>
  )
}

export default XlsSurveyLinked
